












































































































































































import { defineComponent, ref, watch } from "@nuxtjs/composition-api";
import { ValidationProvider, ValidationObserver, extend } from "vee-validate";
import { max, regex, required } from "vee-validate/dist/rules";
import { State, Ward } from "~/modules/customer/types/address";

extend("max", {
  ...max,
  message: "Chỉ định địa chỉ người nhận. Tối đa 100 ký tự",
});

extend("required", {
  ...required,
  message: "Trường này là bắt buộc",
});

extend("regexPhone", {
  ...regex,
  validate(value) {
    const regexPhoneNumber = /([0]+(3|5|7|8|9|1[2|6|8|9]))+([0-9]{8})\b/;
    return regexPhoneNumber.test(value);
  },
  message: "Số điện thoại không hợp lệ",
});

extend("regexName", {
  ...regex,
  validate(value) {
    const regexName =
      /^[a-zA-ZÀÁÂÃÈÉÊÌÍÒÓÔÕÙÚĂĐĨŨƠàáâãèéêìíòóôõùúăđĩũơƯĂẠẢẤẦẨẪẬẮẰẲẴẶẸẺẼỀỀỂưăạảấầẩẫậắằẳẵặẹẻẽềềểếỄỆỈỊỌỎỐỒỔỖỘỚỜỞỠỢỤỦỨỪễệỉịọỏốồổỗộớờởỡợụủứừỬỮỰỲỴÝỶỸửữựỳỵỷỹ\s]+$/;
    return regexName.test(value);
  },
  message: "Họ và tên không hợp lệ.",
});

export default defineComponent({
  name: "AddressNewModal",
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  props: {
    newAddress: {
      type: Boolean,
      required: true,
    },
    states: {
      type: Array as () => State[],
      required: false,
    },
    wards: {
      type: Array as () => Ward[],
      required: false,
    },
    resetForm: {
      type: Boolean,
      required: false,
    },
  },
  setup(props, { emit }) {
    const back = () => emit("back");

    const onChangeState = (regionId: number) => {
      newAddressData.value.ward = null;
      emit("change-state", regionId);
    };

    const newAddressData = ref({
      firstname: "",
      telephone: "",
      region: { region_id: null },
      ward: null,
      street: "",
      default_shipping: false,
      custom_attributes: [],
    });

    const createAddress = (resetValidationFn: () => void) => {
      resetValidationFn();
      const addressData = {
        country_code: "VN",
        firstname: newAddressData.value.firstname || "",
        lastname: "-",
        telephone: newAddressData.value.telephone || "",
        region: newAddressData.value.region,
        city: wardName(newAddressData.value.ward),
        street:
          Array.isArray(newAddressData?.value?.street) &&
          newAddressData?.value?.street.length
            ? newAddressData?.value?.street[0]
            : newAddressData.value?.street || "",
        default_shipping: newAddressData.value.default_shipping || false,
        custom_attributes: [
          { attribute_code: "ward", value: newAddressData.value.ward },
          {
            attribute_code: "ward_id",
            value: wardId(newAddressData.value.ward),
          },
          {
            attribute_code: "ward_name",
            value: wardName(newAddressData.value.ward),
          },
        ],
      };

      emit("create-address", addressData);
    };

    const wardName = (wardCode: string) => {
      const ward = props.wards?.find((ward) => ward.ward_code === wardCode);
      return ward ? ward.ward_name : "";
    };

    const wardId = (wardCode: string) => {
      const ward = props.wards?.find((ward) => ward.ward_code === wardCode);
      return ward ? ward.ward_id : "";
    };

    const toggleDefaultShipping = () => {
      newAddressData.value.default_shipping =
        !newAddressData.value.default_shipping;
    };

    // watch(
    //   () => props.cities,
    //   (newCities) => {
    //     if (newCities?.length > 0 && newAddressData.value.city) {
    //       newAddressData.value.city = newAddressData.value.city;
    //     }
    //   },
    //   { immediate: true }
    // );

    watch(
      () => props.resetForm,
      (newValue) => {
        if (newValue) {
          newAddressData.value = {
            firstname: "",
            telephone: "",
            region: { region_id: null },
            ward: "",
            street: "",
            default_shipping: false,
            custom_attributes: [],
          };
          // ward.value = null;
          emit("reset-form", false);
        }
      }
    );

    return {
      back,
      onChangeState,
      createAddress,
      wardName,
      wardId,
      newAddressData,
      toggleDefaultShipping,
    };
  },
});
